import { LightMode, Text } from "@repo/skapa";
import isEmpty from "lodash/isEmpty";
import { Fragment, type ReactElement } from "react";

export const getOneLineInfo = (
  info: (string | undefined)[],
  divider?: string
) => info.filter((el) => !isEmpty(el)).join(divider ?? ", ");

export const OneLineInfo = ({
  info,
  small,
  bold,
  divider = " | ",
  noWrap,
  color,
}: {
  info: (ReactElement | string | undefined)[];
  small?: boolean;
  bold?: boolean;
  divider?: string;
  noWrap?: boolean;
  color?: string;
}) => {
  const textStyle = bold
    ? small
      ? "Heading.XS"
      : "Heading.S"
    : small
      ? "Body.S"
      : "Body.M";

  return (
    <Text
      textStyle={textStyle}
      color={color ?? (small ? LightMode.colourTextAndIcon3 : undefined)}
      noWrap={noWrap}
    >
      {info
        .filter((el) => !isEmpty(el))
        .map((text, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={i}>
            {i > 0 ? divider : ""}
            {text}
          </Fragment>
        ))}
    </Text>
  );
};
